import _classCallCheck from "/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/esm/inherits.js";
// @ts-ignore
import isoParse from './util/isodate';
import { date as locale } from './locale';
import isAbsent from './util/isAbsent';
import Ref from './Reference';
import BaseSchema from './schema';
var invalidDate = new Date('');
var isDate = function isDate(obj) {
  return Object.prototype.toString.call(obj) === '[object Date]';
};
export function create() {
  return new DateSchema();
}
var DateSchema = /*#__PURE__*/function (_BaseSchema) {
  function DateSchema() {
    var _this;
    _classCallCheck(this, DateSchema);
    _this = _callSuper(this, DateSchema, [{
      type: 'date'
    }]);
    _this.withMutation(function () {
      _this.transform(function (value) {
        if (this.isType(value)) return value;
        value = isoParse(value); // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.

        return !isNaN(value) ? new Date(value) : invalidDate;
      });
    });
    return _this;
  }
  _inherits(DateSchema, _BaseSchema);
  return _createClass(DateSchema, [{
    key: "_typeCheck",
    value: function _typeCheck(v) {
      return isDate(v) && !isNaN(v.getTime());
    }
  }, {
    key: "prepareParam",
    value: function prepareParam(ref, name) {
      var param;
      if (!Ref.isRef(ref)) {
        var cast = this.cast(ref);
        if (!this._typeCheck(cast)) throw new TypeError("`".concat(name, "` must be a Date or a value that can be `cast()` to a Date"));
        param = cast;
      } else {
        param = ref;
      }
      return param;
    }
  }, {
    key: "min",
    value: function min(_min) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : locale.min;
      var limit = this.prepareParam(_min, 'min');
      return this.test({
        message: message,
        name: 'min',
        exclusive: true,
        params: {
          min: _min
        },
        test: function test(value) {
          return isAbsent(value) || value >= this.resolve(limit);
        }
      });
    }
  }, {
    key: "max",
    value: function max(_max) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : locale.max;
      var limit = this.prepareParam(_max, 'max');
      return this.test({
        message: message,
        name: 'max',
        exclusive: true,
        params: {
          max: _max
        },
        test: function test(value) {
          return isAbsent(value) || value <= this.resolve(limit);
        }
      });
    }
  }]);
}(BaseSchema);
export { DateSchema as default };
DateSchema.INVALID_DATE = invalidDate;
create.prototype = DateSchema.prototype;
create.INVALID_DATE = invalidDate;